// extracted by mini-css-extract-plugin
module.exports = {"buttonRootTall":"AzoButton_buttonRootTall__36H3i","disabled":"AzoButton_disabled__3F1lK"};